<template>
  <div>

    <!-- PopUp -->
    <div class="modal fade" id="mainPopUp" tabindex="-1" aria-labelledby="mainPopUpLabel" @click="close" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
        <div v-if="popup" class="modal-content">
          <div class="modal-header">
            <h2 v-if="popup.header" class="modal-title mx-auto text-primary fw-bold" id="mainPopUpLabel">{{ popup.header }}</h2>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          </div>
          <div class="modal-body row">
            <div v-if="popup.thumbnail" class="col-6 col-md-4">
              <img :src="$store.state.config.endpoint + popup.thumbnail" class="rounded img-fluid me-4 mb-3" alt="">
            </div>
            <div v-if="popup.bodytext" class="col-6 col-md-8 d-flex align-items-center">
              {{ popup.bodytext }}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Schließen</button>
            <a type="button" href="mailto:info@mobiletechzone.at" class="btn btn-primary"><i class="fa-regular fa-paper-plane me-2"></i>Mehr Info.</a>
          </div>
        </div>
      </div>
    </div>

    <el-navbar />
    <main class="">
      <section class="slider mt-5 position-relative">
        <div class="card border-0">
          <div class="card-img ratio ratio-16x9">
            <video playinline="playinline" autoplay="autoplay" muted="muted" loop="loop">
              <source src="../../public/storage/tima-miroshnichenko.mp4" type="video/mp4">
            </video>
          </div>
          <div class="card-img-overlay d-flex align-items-center justify-content-center">
            <h2 class="display-3 text-white mx-5 text-center">Die beste Adresse für Handyreparaturen in Österreich!</h2>
          </div>
        </div>
      </section>
      <section class="container my-5">
        <h2 class="display-4 text-primary text-center text-wrap mb-4">
          Welches Gerät willst du reparieren?
        </h2>
        <div class="d-flex justify-content-center">
          <div class="col-12 col-md-8 mb-4">
            <div class="row g-2 mb-3 align-items-center">
              <div class="col-12 col-sm-4 col-lg-3">
                <select class="form-select" v-model="filterByMarker" aria-label="Marke wählen">
                  <option value="all" selected>Alle Marken</option>
                  <option v-for="marker in markers" :key="marker" :value="marker">
                    {{ marker }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-sm-8 col-lg-9">
                <input type="search" id="search" class="form-control" placeholder="Suche dein Gerät"
                  title="Gebe den Namen Ihres Geräts ein" v-model="search" aria-label="Suche"
                  aria-describedby="basic-addon1" />
              </div>
            </div>

            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 d-flex justify-content-center"
              ref="devices">
              <div class="col" v-for="(device, index) in listDevices" :key="index">
                <router-link :to="{
                  name: 'Reparaturwerkstatt',
                  params: { uid: device.uid },
                }" custom v-slot="{ navigate }">
                  <div class="card h-100 border-0" role="link" @click="navigate" @keypress.enter="navigate">
                    <img v-if="device.thumbnail" class="card-img-top"
                      :src="$store.state.config.endpoint + device.thumbnail" :alt="device.thumbnail" />
                    <div class="card-body" v-if="$store.state.updatingPostsObject">
                      <p class="card-text mb-0" title="Marke">
                        <small class="text-primary"><i class="fa-solid fa-sm fa-mobile-screen-button"></i>
                          {{ device.marker }}</small>
                      </p>
                      <h5 class="card-title" title="Gerätename">
                        {{ device.name }}
                      </h5>
                      <p v-if="device.series" class="card-muted small mb-0" title="Serie">
                        Serie: {{ device.series }}
                      </p>
                    </div>
                    <div class="card-body" v-else>
                      <h5 class="card-title placeholder-glow">
                        <span class="placeholder col-6"></span>
                      </h5>
                      <p class="card-text placeholder-glow">
                        <span class="placeholder col-7"></span>
                        <span class="placeholder col-4"></span>
                        <span class="placeholder col-4"></span>
                        <span class="placeholder col-6"></span>
                        <span class="placeholder col-8"></span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="my-2 cards-Services">
        <div class="bg-light text-body badge col-12 py-4">
          <img src="../../public/storage/logo_reparaturbonus_header.png" class="img-fluid" alt="logo reparaturbonus" />
          <div class="py-3">
            <h2 class="display-4 text-primary text-wrap">Förderaktion Reparaturbonus</h2>
            <h5 class="">
              <br />E-Geräte reparieren. <br />50 % der Kosten sparen.
              <br />Umwelt schützen.
            </h5>
            <router-link :to="{ name: 'Reparaturbonus' }" custom v-slot="{ navigate }">
              <span role="link" @click="navigate" class="btn btn-primary mt-2" aria-current="page"
                @keypress.enter="navigate">
                <i class="fa-solid fa-sm fa-circle-info"></i>
                Mehr erfahren
              </span>
            </router-link>
          </div>
        </div>
        <div class="m-0 row row-cols-1 row-cols-md-2 g-4">
          <div class="col p-0 p-md-1 mt-1">
            <div class="card">
              <img src="../../public/storage/s22-ultra-water.jpg" alt="Photo by Imad - Pexels" class="card-img" />
              <div
                class="text-wrap p-4 card-img-overlay badge bg-dark bg-opacity-50 d-flex justify-content-center align-items-center">
                <h2 class="card-title display-4 text-wrap d-block">
                  Handy-Reparatur für Smartphone
                </h2>
              </div>
            </div>
          </div>
          <div class="col p-0 p-md-1 mt-1">
            <div class="card">
              <img src="../../public/storage/macbook-repair.jpg" alt="Photo by Nikolai Chernichenko on Unsplash"
                class="card-img" />
              <div
                class="text-wrap p-4 card-img-overlay badge bg-dark bg-opacity-50 d-flex justify-content-center align-items-center">
                <h2 class="card-title display-4 text-wrap d-block">
                  Service und Reparatur des Mac
                </h2>
              </div>
            </div>
          </div>
          <!--
          <div id="carouselCaptionBottom" class="carousel slide carousel-fade col p-0 p-md-1 mt-1" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active" data-bs-interval="3000">
                <img
                  src="../../public/storage/repair-desk.jpg"
                  class="d-block w-100"
                  alt="Photo by abdulhamid Kwieder"
                />
                <div class="carousel-caption d-none d-md-flex text-wrap p-4 badge bg-dark bg-opacity-50 justify-content-center align-items-center top-0 left-0 h-100">
                  <h2 class="display-4 text-wrap">Ihr Gerät ist bei uns in guten Händen</h2>
                </div>
              </div>
              <div class="carousel-item" data-bs-interval="3000">
                <img
                  src="../../public/storage/repair-desk2.jpg"
                  class="d-block w-100"
                  alt="Photo by abdulhamid Kwieder"
                />
                <div class="carousel-caption d-none d-md-flex text-wrap p-4 badge bg-dark bg-opacity-50 justify-content-center align-items-center top-0 left-0 h-100">
                  <h2 class="display-4 text-wrap">Ihr Gerät ist bei uns in guten Händen</h2>
                </div>
              </div>
            </div>
          </div>-->
          <div class="col p-0 p-md-1 mt-1">
            <div class="card">
              <img src="../../public/storage/repair-desk2.jpg" alt="Photo by abdulhamid kwieder" class="card-img" />
              <div
                class="text-wrap p-4 card-img-overlay badge bg-dark bg-opacity-50 d-flex justify-content-center align-items-center">
                <h2 class="card-title display-4 text-wrap d-block">
                  Ihr Gerät ist bei uns in guten Händen
                </h2>
              </div>
            </div>
          </div>
          <div class="col p-0 p-md-1 mt-1">
            <div class="card">
              <img src="../../public/storage/smartphone-electronic-plates2.jpg" alt="Photo by Imad - Pexels"
                class="card-img" />
              <div
                class="text-wrap p-4 card-img-overlay badge bg-dark bg-opacity-50 d-flex justify-content-center align-items-center">
                <h2 class="card-title display-4 text-wrap d-block">
                  Handy Reparatur bei uns ist günstig und professionell
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="mb-3 mt-5 GoogleReview container">
        <div class="elfsight-app-42c0d5ad-2822-4326-b768-d676b8e4a543"></div>
      </section>
    </main>
    <el-footer />
  </div>
</template>

<script>
import elNavbar from "../components/Navbar.vue";
import elFooter from "../components/Footer.vue";

window.bootstrap = require('bootstrap');

export default {
  name: "LandingPage",

  metaInfo() {
    return {
      title: "Mobile Tech Zone - Startseite",
      titleTemplate: "%s | Mobile Tech Zone",
    };
  },

  components: { elNavbar, elFooter },

  data() {
    return {
      popup: undefined,
      navigate: {},
      target: "",
      listDevices: undefined,
      search: "",
      markers: [],
      filterByMarker: "all",
      lastPositionScroll: 0,
    };
  },

  watch: {
    filterByMarker(val) {
      this.search = "";
      if (val == "all") {
        return;
      }
    },

    search(val) {
      if (val.length <= 0) {
        this.listDevices = [];
        return;
      }
      this.listDevices = [];
      this.$store.state.updatingPostsObject.map((element) => {
        if (
          this.filterByMarker == "all" ||
          this.filterByMarker == element.marker
        ) {
          if (
            element.marker.toUpperCase().indexOf(val.toUpperCase()) > -1 ||
            element.series.toUpperCase().indexOf(val.toUpperCase()) > -1 ||
            element.name.toUpperCase().indexOf(val.toUpperCase()) > -1
          ) {
            this.listDevices.push(element);
          }
        }
      });
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.getDevices();

      if (!localStorage.popup) {
        this.$store.state.modules.api
          .viewPopupThumbnail()
          .then((resp) => {
            if (resp.status == 200) {
              this.popup = resp.data.result[0];
              console.log(this.popup)
              var myModal = new bootstrap.Modal(document.getElementById('mainPopUp'), {
                keyboard: false
              })
              myModal.show();

            } else {

            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    });
  },

  methods: {
    close() {
      localStorage.setItem('popup', true);
    },

    getDevices() {
      this.$store.state.updatingPostsObject = [];
      this.$store.state.modules.api
        .getDevices()
        .then((resp) => {
          if (resp.status == 200) {
            resp.data.units.map((i) => {
              if (this.markers.indexOf(i.marker) == -1) {
                this.markers.push(i.marker);
              }
            });
            this.$store.state.updatingPostsObject = resp.data.units;
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },
  },
};
</script>

<style scoped></style>
